import type { AiBusinessCenterModule } from '../types'

/**
 * 订单管理独立应用配置。
 *
 * 中台卡片打开独立窗口后，独立布局根据该配置提取 order-management
 * 动态路由下的菜单，只展示订单管理模块自己的功能。
 */
export const orderManagementModule: AiBusinessCenterModule = {
  key: 'order-management',
  label: '订单管理',
  desc: '客户 / 跟进 / 合同 / 开票 / 税务 / 报表',
  path: '/order-management',
  homePath: '/order-management/dashboard',
  icon: 'ep:document',
  color: '#1677ff'
}
